<template>
  <v-container
    fill-height
    fluid
  >
    <v-row class="align-center justify-center">
      <v-col
        sm="8"
        md="6"
        lg="3"
      >
        <v-card class="elevation-12 pa-4 text-center">
          <v-card-text>
            <form-wrapper :validator="$v.employee">
              <v-form
                ref="form"
                @submit.prevent="submit"
              >
                <template v-if="_.get(cashRegister, 'store')">
                  <img
                    v-if="_.get(cashRegister, 'store.storeLogoUrl')"
                    :src="cashRegister.store.storeLogoUrl"
                    class="mb-3"
                    width="200"
                  >
                  <img
                    v-else
                    class="mb-3"
                    src="/static/images/vaporshop-logo.jpg"
                    width="200"
                  >
                </template>

                <h1 class="font-weight-light mb-6">{{ $t('Login') }}</h1>
                <numeric-keyboard
                  :layout="[`1 2 3`, `4 5 6`, `7 8 9`, `{clear} 0 {bksp}`]"
                  wrapper-background="transparent"
                  keyboard-background="transparent"
                  @clear="clear"
                  @input="input"
                  @submit="submit"
                >
                  <form-group
                    slot="input"
                    name="pin"
                  >
                    <template slot-scope="{ attrs }">
                      <v-text-field
                        id="pin"
                        ref="pin"
                        v-bind="attrs"
                        v-model="employee.pin"
                        autocomplete="off"
                        autofocus
                        class="input-pin"
                        filled
                        label="PIN Code"
                        maxlength="4"
                        single-line
                        type="text"
                        @blur="$v.employee.pin.$touch()"
                        @input="$v.employee.pin.$touch()"
                      />
                    </template>
                  </form-group>
                </numeric-keyboard>
                <div
                  v-show="$wait.is('logging in')"
                  class="mt-6"
                >
                  <v-progress-circular
                    :indeterminate="true"
                    class="mt-0"
                    color="primary"
                  />
                </div>
              </v-form>
            </form-wrapper>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { numeric } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import validationMixin from '@/utils/mixins/validationMixin'
import store from '@/store'
import NumericKeyboard from '@/components/NumericKeyboard'
import screenfull from 'screenfull'
import Vue from 'vue'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    NumericKeyboard
  },

  mixins: [
    validationMixin
  ],

  data: () => ({
    employee: { pin: '' },
    pageTitle: Vue.i18n.translate('Login')
  }),

  computed: {
    ...mapState(['cashRegister'])
  },

  validations: {
    employee: {
      pin: {
        numeric
      }
    }
  },

  watch: {
    'employee.pin': function (pin) {
      if (pin.length === 4) {
        this.submit()
      }
    }
  },

  methods: {
    submit () {
      if (!this.validate()) return
      this.$wait.start('logging in')
      return this.$store.dispatch('AUTH/LOGIN', { pin: this.employee.pin })
        .then(() => {
          if (this.$route.path !== '/') {
            this.$router.push('/').catch(err => console.log(err))
          }
          this.forceFullScreen()
        })
        .catch((data) => {
          if (data && data.status && data.status === 500) {
            this.helpers.toastError('Authentication failed')
          } else {
            if (data && data.message) {
              this.helpers.toastError(data.message)
            }
          }

          this.clear()
          this.focusInput()
        })
        .finally(() => this.$wait.end('logging in'))
    },
    focusInput () {
      this.$nextTick(this.$refs.pin.focus)
    },
    input (input) {
      this.employee.pin = input
    },
    clear () {
      this.employee.pin = ''
    },
    forceFullScreen () {
      if (screenfull.isEnabled && !screenfull.isFullscreen) {
        screenfull.request().then(() => this.$store.dispatch('SET_FULLSCREEN', true))
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    // redirect to homepage if already logged in
    const isAuthenticated = store.getters['AUTH/isAuthenticated']
    if (isAuthenticated) {
      next('/')
    } else {
      next()
    }
  }
}
</script>

<style>
@font-face {
    font-family: 'Password Dots';
    src: url('~/static/fonts/Password-Dots.eot');
    src: url('~/static/fonts/Password-Dots.eot?#iefix') format('embedded-opentype'),
        url('~/static/fonts/Password-Dots.woff2') format('woff2'),
        url('~/static/fonts/Password-Dots.woff') format('woff'),
        url('~/static/fonts/Password-Dots.ttf') format('truetype'),
        url('~/static/fonts/Password-Dots.svg#Password-Dots') format('svg');
    font-weight: normal;
    font-style: normal;
}
</style>

<style lang="scss" scoped>
.input-pin {
  font-size: 1.5em;
  /deep/ input {
   font-family: 'Password Dots'
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue